import script from "./DecaReviewModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DecaReviewModal.vue?vue&type=script&setup=true&lang=js"

import "./DecaReviewModal.vue?vue&type=style&index=0&id=6285a520&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6285a520"]])

export default __exports__